const data = [
  {
    name: "mon",
    CompletedTasks: 2,
    ActiveTasks: 3,
  },
  {
    name: "tue",
    CompletedTasks: 4,
    ActiveTasks: 5,
  },
  {
    name: "wed",
    CompletedTasks: 7,
    ActiveTasks: 9,
  },
  {
    name: "thu",
    CompletedTasks: 8,
    ActiveTasks: 10,
  },
  {
    name: "fri",
    CompletedTasks: 10,
    ActiveTasks: 11,
  },
  {
    name: "sat",
    CompletedTasks: 12,
    ActiveTasks: 15,
  },
  {
    name: "sun",
    CompletedTasks: 14,
    ActiveTasks: 15,
  },
];

export default data;
